import { Model } from ".";

/* eslint-disable */
export default class Entry extends Model {
  name!: string;
  iconUrl!: string;

  detectionsCount?: number;
  detectionsCountCompare?: number;

  radioCount?: number;
  tvCount?: number;

  tvTabCount?: number;
  tvSponsorCount?: number;
  radioTabCount?: number;
  radioSponsorCount?: number;

  shareOfVoice?: number;
  logoUrls?: string[];

  vodPresence?: number;
  vodDetectionsCount?: number;
  vodDetectionsCountCompare?: number;

  constructor(data: any, included = []) {
    super(data, included);
    this.setLogoUrls();
  }

  get detectionsCountDelta(): number | undefined {
    return this.computeDelta(this.detectionsCount, this.detectionsCountCompare);
  }

  get vodDetectionsCountDelta(): number | undefined {
    return this.computeDelta(
      this.vodDetectionsCount,
      this.vodDetectionsCountCompare
    );
  }

  get radioCountPercentage(): number | undefined {
    if (this.radioCount === undefined || this.tvCount === undefined) {
      return undefined;
    }

    if (this.radioCount === 0) {
      return 0;
    }

    return (this.radioCount / (this.radioCount + this.tvCount)) * 100;
  }

  get tvCountPercentage(): number | undefined {
    if (this.radioCount === undefined || this.tvCount === undefined) {
      return undefined;
    }

    if (this.tvCount === 0) {
      return 0;
    }

    return (this.tvCount / (this.tvCount + this.radioCount)) * 100;
  }

  setLogoUrls() {
    const candidates = [this.iconUrl];
    if ("company" in this && this["company"]["iconUrl"]) {
      candidates.push(this["company"]["iconUrl"]);
    }

    this.logoUrls = candidates;
  }

  computeDelta(
    value?: number,
    valueToCompareWith?: number
  ): number | undefined {
    if (value && valueToCompareWith) {
      let delta;
      if (typeof value === "number") {
        delta = (value as number) - valueToCompareWith;
      } else {
        delta =
          (parseFloat(value as unknown as string) || 0.0) - valueToCompareWith;
      }
      return (delta / valueToCompareWith) * 100;
    }

    if (valueToCompareWith === undefined) {
      return undefined;
    }

    return 0;
  }
}
